import React, { useState, useEffect } from "react";
import { Menu, X, Phone, ShieldCheck, MapPin } from "lucide-react";
import RedlineLogo from "./RedlineLogo";
import { trackEvent, trackPhoneClick } from "../utils/analytics";

const NAV = [
  { label: "How It Works", href: "#how" },
  { label: "Capabilities", href: "#services" },
  { label: "AskRedline", href: "#askredline" },
  { label: "Why Redline", href: "#difference" },
  { label: "Results", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goConsult = () => {
    trackEvent("consultation_button_click", {
      category: "lead_generation", action: "button_click",
      label: "header_consultation_button", value: 10, contact_method: "navigation",
    });
    document.getElementById("consultation")?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header className="fixed w-full z-50 top-0">
      {/* Utility bar */}
      <div className="hidden md:block bg-[#0F172A] text-white/65 text-[12px]">
        <div className="max-w-7xl mx-auto px-6 h-9 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5 text-[#FF5252]" /> Licensed TX DPS #B30959201 · Fully Insured</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#FF5252]" /> Austin &amp; Central Texas</span>
            <a href="tel:+15123636584" onClick={() => trackPhoneClick("utility")} className="flex items-center gap-1.5 font-medium text-white hover:text-[#FF6B6B] transition-colors">
              <Phone className="w-3.5 h-3.5 text-[#FF5252]" /> (512) 363-6584
            </a>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className={`transition-all duration-300 border-b ${scrolled ? "bg-white/95 backdrop-blur-xl border-black/[0.07] shadow-[0_4px_24px_-12px_rgba(15,23,42,0.25)]" : "bg-white border-transparent"}`}>
        <div className="max-w-7xl mx-auto px-6 h-[68px] flex items-center justify-between">
          <a href="#home"><RedlineLogo width={200} height={38} dark /></a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <a key={n.href} href={n.href}
                 className="text-[13.5px] font-medium text-[#0F172A]/70 hover:text-[#D32F2F] transition-colors duration-200">
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center">
            <button onClick={goConsult} data-testid="header-consultation-btn"
                    className="rounded-full bg-[#D32F2F] hover:bg-[#B71C1C] text-white text-sm font-medium px-6 py-2.5 transition-all hover:scale-[1.02]">
              Request a Consultation
            </button>
          </div>

          <button className="lg:hidden text-[#0F172A]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-b border-black/[0.07] shadow-lg">
          <nav className="flex flex-col gap-1 px-6 py-5">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)}
                 className="py-2.5 text-sm font-medium text-[#0F172A]/75 hover:text-[#D32F2F] border-b border-black/[0.04]">
                {n.label}
              </a>
            ))}
            <a href="tel:+15123636584" onClick={() => trackPhoneClick("mobile_menu")} data-testid="header-phone"
               className="py-2.5 flex items-center gap-2 text-sm font-semibold text-[#0F172A]">
              <Phone className="w-4 h-4 text-[#D32F2F]" />(512) 363-6584
            </a>
            <button onClick={goConsult}
                    className="mt-3 rounded-full bg-[#D32F2F] text-white text-sm font-medium px-6 py-3">
              Request a Consultation
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
